import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/fc_logo_primary_orange_transparent.png'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  alt: "Forechamp logo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "top-line transition" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "middle-line transition" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "bottom-line transition" }, null, -1)
const _hoisted_6 = [
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = {
  class: "transition",
  role: "navigation"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "transition" }, "Home", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "transition" }, "Blog", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", { class: "transition" }, "Podcast", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["transition", { 'showing-mobile-nav': _ctx.state.showMobileNav }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_link, {
        to: "/",
        id: "logo"
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("div", {
        id: "nav-menu-button",
        class: "transition",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleNav()))
      }, _hoisted_6),
      _createElementVNode("nav", _hoisted_7, [
        _createVNode(_component_router_link, {
          to: "/",
          onClick: _ctx.closeNav
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/blog",
          onClick: _ctx.closeNav
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_router_link, {
          to: "/podcast",
          onClick: _ctx.closeNav
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ], 2))
}